import ConfirmationModal from "../../components/ConfirmationModal";

// An approval either just applies the modification, or applies it and takes money.
// Only the paying case gets the teal "charge" treatment; the rest stay on the gold
// approve tone.
const getApprovalPrompt = ({ chargeAmount = 0, isDeferredPayment }) => {
    if (!chargeAmount) {
        return {
            title: "Would you like to approve this booking modification?",
            confirmLabel: "Approve",
            variant: "gold",
        };
    }

    if (isDeferredPayment) {
        return {
            title: "Would you like to approve this booking modification and update the booking fee?",
            confirmLabel: "Approve",
            variant: "gold",
        };
    }

    return {
        title: `Would you like to approve this booking modification and charge the additional amount of ${chargeAmount.toLocaleString()} JPY?`,
        confirmLabel: `¥ Charge ${chargeAmount.toLocaleString()} JPY`,
        variant: "primary",
    };
};

const ApproveConfirmationModal = ({
    data,
    isDeferredPayment,
    processingAction,
    onClose,
    onConfirm,
}) => {
    const prompt = getApprovalPrompt({
        chargeAmount: data?.chargeAmount || 0,
        isDeferredPayment,
    });

    return (
        <ConfirmationModal
            show
            title={prompt.title}
            description="Please make sure to review all modifications thoroughly, as changes are irreversible."
            variant={prompt.variant}
            confirmLabel={prompt.confirmLabel}
            busyLabel="Processing..."
            cancelLabel="Back"
            isBusy={processingAction === "approved"}
            onCancel={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default ApproveConfirmationModal;
